import ApiClient from "./ApiClient";
import Selectitem from "../models/shared/SelectItem";
import { VehicleType } from "../models/vehicle-type/VehicleType";

export default class VehicleTypeApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "vehihcle-types/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getVehicleTypes() {
    const vehicleTypes = await this.apiClient.get(this.urlPrefix);

    return <Selectitem<VehicleType>[]>vehicleTypes;
  }
}
